import {C240LoaderActions} from '../actionTypes/c240_loader.constant';
import axios from 'axios';
import { AuthHeader } from "../helper/auth.token"
import { message } from "antd";
import cookie from "react-cookies";
var querystring = require('querystring');

export const updateEditorState = (editor_state) => ({
    type: C240LoaderActions.UPDATE_C240_EDITOR_MODE,
    response: editor_state,
})

export const updateBannerState = (banner_state) => ({
    type: C240LoaderActions.UPDATE_BANNER_STATE,
    response: banner_state,
})


export const updateLoaderState = (loader_state) => ({
    type: C240LoaderActions.UPDATE_LOADER_STATE,
    response: loader_state,
})